import { gql, TypedDocumentNode } from '@apollo/client'

import type { ItemChildren } from './project-details-types'

const CURRENT_CONTENT = `
  currentContent: content_version(args: { content_type: "current" }) {
    submodels
    external_metadata
    content
    qualityMetrics: quality_metrics
    comments
    inputs
  }
`

const SAVED_CONTENT = `
  savedContent: content_version(args: { content_type: "saved" }) {
    submodels
    external_metadata
    content
    qualityMetrics: quality_metrics
    comments
    inputs
  }
`

const ITEM_CHILDREN = /* GraphQL */ `
  children(where: { is_archived: { _eq: false } }) {
    id
    identifier
    type: content_type
    ${CURRENT_CONTENT}
    ${SAVED_CONTENT}
    modelInfo: ai_model {
      optionPrefix: public_mapper(path: "$.option_prefix")
    }
  }
`

export const GET_ITEM_CHILDREN: TypedDocumentNode<{ item: ItemChildren }, { itemId: string }> = gql`
  query itemChildren($itemId: uuid!) {
    item: item_by_pk(id: $itemId) {
      id
      ${ITEM_CHILDREN}
    }
  }
`
